<div class="cliente-pre-baixa-card-info card">
    <h6 class="card-header card-title" (click)="toggleCollapse()">
        <i class="fas fa-caret-down" aria-hidden="true" *ngIf="!isCollapseOpened"></i>
        <i class="fas fa-caret-up" aria-hidden="true" *ngIf="isCollapseOpened"></i>        
        {{title}}      
    </h6>
    <div class="card-body" #collapse>
        <div class="row">
            <div class="form-group col-12 col-md-9">
                <label for="preBaixadoPor" class="col-form-label">Pré-Baixado Por</label>
                <input type="text" class="form-control" [value]="usuarioPreBaixa?.nome" name="preBaixadoPor" id="preBaixadoPor"
                    disabled="disabled" readonly="readonly">
            </div>
            <div class="form-group col-12 col-md-3">
                <label for="dataPreBaixa" class="col-form-label">Pré-Baixado em</label>
                <input type="text" class="form-control text-center" [value]="dataPreBaixa | date: 'dd/MM/yyyy - HH:mm:ss'" name="dataPreBaixa" id="dataPreBaixa"
                    disabled="disabled" readonly="readonly">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="motivoBaixa" class="col-form-label">Motivo</label>
                <textarea class="form-control" [value]="motivoBaixa" name="motivoBaixa" id="motivoBaixa"
                    rows="10" disabled="disabled" readonly="readonly">
                </textarea>
            </div>
        </div>                     
    </div>                       
</div>